import { FC } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { wacToken } from "@/libraries/design/foundations";

export interface FreeSubheadingProps {
    returnString?: boolean;
}

export const FreeSubheading: FC<FreeSubheadingProps> = ({ returnString }) => {
    const intl = useIntl();

    const subHeaderText = intl.formatMessage({
        id: "signupForm.accountCreation.subHeaderText.jpd.free",
        defaultMessage:
            "It's free for up to 3 creators - no credit card needed."
    });

    return returnString ? (
        subHeaderText
    ) : (
        <p css={subHeaderCss}>{subHeaderText}</p>
    );
};

export const StandardSubheading: FC<FreeSubheadingProps> = ({
    returnString
}) => {
    const intl = useIntl();

    const subHeaderText = intl.formatMessage({
        id: "signupForm.accountCreation.subHeaderText.jpd.free",
        defaultMessage: "It's free to get started - no credit card needed."
    });

    return returnString ? (
        subHeaderText
    ) : (
        <p css={subHeaderCss}>{subHeaderText}</p>
    );
};

const subHeaderCss = css({
    color: wacToken("color.primary.black"),
    margin: "8px 0 24px",
    textAlign: "center",
    fontFamily: "Charlie Text"
});
